import { Route } from 'vue-router';
import store from '@/store';

// ページ遷移時
export default function beforeEach(to: Route, from: Route, next: (to?: string | false) => void): void {
  // apiをキャンセル
  store.dispatch('error/apiCancel');
  // ページ遷移
  next();
}
